import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import Footer from './HorizontalLayout/Footer';

const NonAuthLayout = ({children}) => {
  const location = useLocation();

  const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  useEffect(() => {
    const currentPage = capitalizeFirstLetter(location.pathname);
    document.title = `${currentPage} | Brother TECNET | IPM Dealer Service Platform`;
  }, [location.pathname]);

  return (
    <>
      {children}
      <Footer />
    </>
  );
};

export default NonAuthLayout;
